import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p18 from '../assets/images/email.gif';
import p19 from '../assets/images/email1.gif';
import p20 from '../assets/images/email2.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b> Create your Email with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p18} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://accounts.google.com/signup/v2/webcreateaccount?hl=en&flowName=GlifWebSignIn&flowEntry=SignUp" className="btn btn-xl btn-light mr-4">
        Create  Gmail Account
        </a>
       
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://login.yahoo.com/account/create" className="btn btn-xl btn-light mr-4">
         Yahoo Account !
        </a>
        
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://signup.live.com/?wa=wsignin1.0&rpsnv=13&ct=1588738258&rver=7.0.6738.0&wp=MBI_SSL&wreply=https%3A%2F%2Faccount.microsoft.com%2Fauth%2Fcomplete-signin%3Fru%3Dhttps%253A%252F%252Faccount.microsoft.com%252F%253Flang%253Den-ie%2526refd%253Daccount.microsoft.com%2526refp%253Dsignedout-index&id=292666&lw=1&fl=easi2&ru=https%3A%2F%2Faccount.microsoft.com%2Faccount%3Flang%3Den-ie&contextid=B5E4D2B166EC3C20&bk=1588738269&uiflavor=web&lic=1&mkt=EN-GB&lc=2057&uaid=d00dcfd8bb8a46ea1122dc6951aac113" className="btn btn-xl btn-light mr-4">
          Microsoft Account
        </a>
       
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.yopmail.com/en/" className="btn btn-xl btn-light mr-4">
         Yop Mail
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.sendinblue.com/" className="btn btn-xl btn-light mr-4">
         Sendin Blue
        </a>
       
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p19} alt="" />
          <h2 className="mb-5">Create your mail account on the Internet Smartly..<i className="fa fa-envelope fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://login.aol.com/account/create?lang=en-US&src=help&.done=https%3A%2F%2Fapi.login.aol.com%2Foauth2%2Fauthorize%3Fclient_id%3Ddj0yJmk9eTFxY1BPS0tNRFNmJmQ9WVdrOVJFVm1aVlpyTkdjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD01OQ--%26language%3Den-US%26nonce%3DBHDU1Q1524j28xbmKMlGC0ZuS5UmZDBA%26redirect_uri%3Dhttps%253A%252F%252Foidc.help.aol.com%252Fcallback%26response_type%3Dcode%26scope%3Dopenid%2Bopenid2%2Bsdps-r%26src%3Dhelp%26state%3DeyJhbGciOiJSUzI1NiIsImtpZCI6IjZmZjk0Y2RhZDExZTdjM2FjMDhkYzllYzNjNDQ4NDRiODdlMzY0ZjcifQ.eyJyZWRpcmVjdFVyaSI6Imh0dHBzOi8vaGVscC5hb2wuY29tL3Byb2R1Y3RzL2FvbC1tYWlsIn0.A_ZshAI7JlwiRrtdxyEeJFGs7EDnoWwbqi2Drp3wRRBRBL0-iQA330DEN_w3AbV_Pq7-cy_zvvQC6JKBy8uaYK7QIISUBc_OIF7M987WH5iIjpTzpl2_jOaX-8y7NHbe8bUCIREnfA47utGmPehC8W1gPfNHA941Eh4wn-GgDwY&specId=yidReg&done=https%3A%2F%2Fapi.login.aol.com%2Foauth2%2Fauthorize%3Fclient_id%3Ddj0yJmk9eTFxY1BPS0tNRFNmJmQ9WVdrOVJFVm1aVlpyTkdjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD01OQ--%26language%3Den-US%26nonce%3DBHDU1Q1524j28xbmKMlGC0ZuS5UmZDBA%26redirect_uri%3Dhttps%253A%252F%252Foidc.help.aol.com%252Fcallback%26response_type%3Dcode%26scope%3Dopenid%2Bopenid2%2Bsdps-r%26src%3Dhelp%26state%3DeyJhbGciOiJSUzI1NiIsImtpZCI6IjZmZjk0Y2RhZDExZTdjM2FjMDhkYzllYzNjNDQ4NDRiODdlMzY0ZjcifQ.eyJyZWRpcmVjdFVyaSI6Imh0dHBzOi8vaGVscC5hb2wuY29tL3Byb2R1Y3RzL2FvbC1tYWlsIn0.A_ZshAI7JlwiRrtdxyEeJFGs7EDnoWwbqi2Drp3wRRBRBL0-iQA330DEN_w3AbV_Pq7-cy_zvvQC6JKBy8uaYK7QIISUBc_OIF7M987WH5iIjpTzpl2_jOaX-8y7NHbe8bUCIREnfA47utGmPehC8W1gPfNHA941Eh4wn-GgDwY" className="btn btn-xl btn-light mr-4">
         AOL 
        </a>
        
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://support.mail.com/info/reject.html#.1258-header-signup2-1" className="btn btn-xl btn-light mr-4">
        Mail
        </a>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.zoho.com/signup.html" className="btn btn-xl btn-light mr-4">
         Zoho
        </a>
        
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://passport.yandex.com/registration/mail?from=mail&require_hint=1&origin=hostroot_homer_reg_com&retpath=https%3A%2F%2Fmail.yandex.com%2F&backpath=https%3A%2F%2Fmail.yandex.com%3Fnoretpath%3D1" className="btn btn-xl btn-light mr-4">
         Yandex Mail
        </a>
        
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.icloud.com/mail" className="btn btn-xl btn-light mr-4">
         iCloud
        </a>
       
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p20} alt="" />
          <h2 className="mb-5">Connect. Organize. Get Things Done..<i className="fa fa-envelope fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.fastmail.com/" className="btn btn-xl btn-light mr-4">
         Fast Mail
        </a>
       
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://temp-mail.org/" className="btn btn-xl btn-light mr-4">
         Temp-Mail
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.liveinternet.ru/" className="btn btn-xl btn-light mr-4">
         Live Internet
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://mailchimp.com/" className="btn btn-xl btn-light mr-4">
         Mail Chimp
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://outlook.live.com/owa/" className="btn btn-xl btn-light mr-4">
      Outlook
        </a>
       
      </div>
    </section>










    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
